module.exports = __webpack_public_path__ + "img/Balsnack-logo.2f5fbe7f.png";